import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DashboardOrderDateType, DashboardParam } from '../dashboard.models';
import { DashboardService } from '../dashboard.service';
import { MatDrawer } from '@angular/material/sidenav';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from 'src/app/shared/notifications/notifications.models';
import { CompaniesService } from '../../companies/companies.service';
import { Company } from '../../companies/companies.models';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild('drawer') drawer: MatDrawer;
  locationSubscription: Subscription;

  dashboard: any;
  selectedPeriod: string;
  params: DashboardParam = new DashboardParam();
  filterCount: number = 0;
  dateFormat: string = 'YYYY-MM-DD';
  dateTimeFormat: string = 'YYYY-MM-DDTHH:mm:ss';
  today: string = moment().format('DD.MM.yyyy. HH:mm:ss');
  userData: any = [];
  selectedTab: NotificationType;
  company: Company;

  constructor(
    public authService: AuthService,
    public utilityService: UtilityService,
    private dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    public companiesService: CompaniesService
  ) { }

  ngOnInit(): void {
    if (this.authService.userType != 'SYSTEM')
      this.filterPeriod('MONTH');

    this.companiesService.getById(this.companiesService.url, this.authService.companyId, (company: Company) => {
      this.company = company;
    })

    this.userData = [];
    this.userData.push({
      username: this.authService.username,
      userType: this.authService.userType
    });

    setInterval(() => {
      this.today = moment().format('DD.MM.yyyy. HH:mm:ss');
    }, 1000)

    this.locationSubscription = this.activatedRoute.params.subscribe(routeParams => {
      if (routeParams && routeParams.type == "notifications" && routeParams.tab)
        this.selectedTab = routeParams.tab.toUpperCase();
    });
  }

  ngOnDestroy() {
    this.locationSubscription.unsubscribe();
  }

  toggleDrawer() {
    this.drawer.toggle();
  }

  filterPeriod(period: string) {
    this.selectedPeriod = period;
    this.setPeriodParams(period);
    this.dashboardService.getDashboard(this.params, (response) => {
      this.dashboard = response;
    });
  }

  setPeriodParams(period: string) {
    switch (period) {
      case 'TODAY':
        this.params.periodFrom = moment().format(this.dateFormat);
        this.params.periodTo = moment().format(this.dateFormat);
        break;
      case 'WEEK':
        this.params.periodFrom = moment().startOf('week').format(this.dateFormat);
        this.params.periodTo = moment().endOf('week').format(this.dateFormat);
        break;
      case 'MONTH':
        this.params.periodFrom = moment().startOf('month').format(this.dateFormat);
        this.params.periodTo = moment().endOf('month').format(this.dateFormat);
        break;
    }
  }

  filterEvent(params: DashboardParam) {
    this.params.dashboardCustomerType = params.dashboardCustomerType;
    this.params.orderDateType = params.orderDateType;
    this.params.municipalities = params.municipalities;
    this.params.productMerchandiseGroups = params.productMerchandiseGroups;
    this.params.deliveryLocations = params.deliveryLocations;
    this.params.pointsOfSale = params.pointsOfSale;

    if (params.periodFrom != null || params.periodTo != null) {
      this.params.periodFrom = params.periodFrom ? params.periodFrom : moment().format(this.dateTimeFormat);
      this.params.periodTo = params.periodTo ? params.periodTo : moment().format(this.dateTimeFormat);
      this.selectedPeriod = null;
    }

    this.updateFilterCount(params);

    this.dashboardService.getDashboard(this.params, (response) => {
      this.dashboard = response;
      this.toggleDrawer();
    });
  }

  updateFilterCount(params: DashboardParam) {
    this.filterCount = 0;
    if (params.dashboardCustomerType != null)
      this.filterCount++;
    if (params.orderDateType != DashboardOrderDateType.ORDER_DATE)
      this.filterCount++;
    if (params.productMerchandiseGroups != null && params.productMerchandiseGroups.length > 0)
      this.filterCount++;
    if (params.municipalities != null && params.municipalities.length > 0)
      this.filterCount++;
    if (params.pointsOfSale != null && params.pointsOfSale.length > 0)
      this.filterCount++;
    if (params.deliveryLocations != null && params.deliveryLocations.length > 0)
      this.filterCount++;
    if (this.selectedPeriod == null)
      this.filterCount++;
  }
}
